module.exports = __webpack_public_path__ + "img/symbol_10.a8ffe2d4.png";